import EquipmentDashboard from '@/components/equipment/dashboard/dashboard.vue';
import EquipmentForm from '@/components/equipment/operations/operation_form.vue';
import EquipmentLayout from '@/components/equipment/equipment_layout.vue';
import EquipmentInspectionDetails from '@/components/equipment/inspections/inspection_details.vue';
import EquipmentInspections from '@/components/equipment/inspections/inspections.vue';
import Configurations from '@/components/equipment/configuration/configuration_page.vue';
import EquipmentManageRegions from '@/components/equipment/operations/manage_regions.vue';
import EquipmentIssueForm from '@/components/issues/issue_form.vue';
import IssueLocationEquipment from '@/components/equipment/location/issue_location_equipment.vue';
import EquipmentIssueHistory from '@/components/issues/issue_history.vue';
import EquipmentRegions from '@/components/equipment/regions/regions.vue';
import EquipmentHealthReportForm from '@/components/equipment/equipment_health_report/equipment_health_report_form.vue';
import EquipmentIssueList from '@/components/equipment/tasks/issue_list.vue';
import EquipmentTaskList from '@/components/equipment/tasks/task_list.vue';
import EquipmentTasks from '@/components/equipment/tasks/tasks.vue';
import RegionsIssue from '@/components/regions/regions_issue_view.vue';
import RegionsIssueLocation from '@/components/equipment/regions/regions_issue_location.vue';
import MonitoringPlans from '@/components/equipment/monitoring_plans/monitoring_plans.vue';
import PlanDetails from '@/components/monitoring_plans/plan_details.vue';
import MonitoringPlanForm from '@/components/monitoring_plans/monitoring_plan_form.vue';
import TaskComments from '@/components/monitoring_plans/tasks/task_comments.vue';
import TaskDetails from '@/components/monitoring_plans/tasks/task_details.vue';
import TaskLayout from '@/components/monitoring_plans/tasks/task_layout.vue';
import TaskResults from '@/components/monitoring_plans/tasks/task_results.vue';
import only from '../only';

export default [
  {
    path: 'equipment/:equipmentId',
    component: EquipmentLayout,
    props: only('organisationId', 'equipmentId'),
    children: [
      {
        path: '',
        name: 'equipment',
        component: EquipmentDashboard,
        props: true,
      },
      {
        path: 'regions/:issueType(equipment)',
        name: 'equipmentRegions',
        component: EquipmentRegions,
        props: true,
        children: [
          {
            path: 'inspections/:inspectionId/issues/:issueId',
            name: 'equipmentRegionsIssue',
            component: RegionsIssue,
            props: true,
          },
          {
            path: 'inspections/:inspectionId/issues/:issueId/location/equipment',
            name: 'equipmentIssuesLocationTypeEquipment',
            component: RegionsIssueLocation,
            props: true,
          },
        ],
      },
      {
        path: 'monitoring_plans/:scope(plans|archived_plans)',
        name: 'equipmentPlans',
        component: MonitoringPlans,
        props: only('organisationId', 'equipmentId', 'scope'),
        children: [
          {
            path: ':planId',
            name: 'equipmentPlan',
            component: PlanDetails,
            props: true,
          },
        ],
      },
      {
        path: ':scope(inspections|approved_inspections)',
        name: 'equipmentInspections',
        component: EquipmentInspections,
        props: only('organisationId', 'equipmentId', 'scope'),
        children: [
          {
            path: ':inspectionId',
            name: 'equipmentInspection',
            component: EquipmentInspectionDetails,
            props: true,
          },
        ],
      },
      {
        path: 'tasks',
        component: EquipmentTasks,
        props: only('organisationId', 'equipmentId'),
        children: [
          {
            path: '',
            name: 'equipmentTasks',
            redirect: {
              name: 'equipmentTasksCategory',
              params: { category: 'all' },
            },
          },
          {
            path: ':category(all|current|past_due|completed)',
            name: 'equipmentTasksCategory',
            component: EquipmentTaskList,
            props: true,
          },
          {
            path: ':category(issues_missing_tasks|resolved_issues)',
            name: 'equipmentTaskIssuesCategory',
            component: EquipmentIssueList,
            props: true,
          },
        ],
      },
    ],
  },
  {
    path: 'equipment/:equipmentId/monitoring_plans/plans/:planId/edit',
    name: 'equipmentEditPlan',
    component: MonitoringPlanForm,
    props: true,
  },
  {
    path: 'equipment/:equipmentId/monitoring_plans/plans/new',
    name: 'equipmentNewPlan',
    component: MonitoringPlanForm,
    props: true,
  },
  {
    path: 'equipment/:equipmentId/monitoring_plans/plans/:planId/points/:pointId/tasks/:taskId',
    component: TaskLayout,
    props: true,
    children: [
      {
        path: '',
        name: 'equipmentTask',
        component: TaskDetails,
        props: true,
      },
      {
        path: 'comments',
        name: 'equipmentTaskComments',
        component: TaskComments,
        props: true,
      },
      {
        path: 'task_results',
        name: 'equipmentTaskResults',
        component: TaskResults,
        props: true,
      },
    ],
  },
  {
    path: 'equipment/:equipmentId/edit',
    name: 'editEquipment',
    component: EquipmentForm,
    props: true,
  },
  {
    path: 'equipment/new',
    name: 'newEquipment',
    component: EquipmentForm,
    props: true,
  },
  {
    path: 'equipment/:equipmentId/configuration',
    name: 'equipmentConfiguration',
    component: Configurations,
    props: true,
    children: [
      {
        path: 'equipment',
        name: 'equipmentConfigurationEquipment',
        component: Configurations,
        props: true,
      },
    ],
  },
  {
    path: 'equipment/:equipmentId/regions/edit',
    name: 'equipmentManageRegions',
    component: EquipmentManageRegions,
    props: true,
  },
  {
    path: 'equipment/:equipmentId/inspections/:inspectionId/issues/new',
    name: 'newEquipmentIssue',
    component: EquipmentIssueForm,
    props: true,
  },
  {
    path: 'equipment/:equipmentId/inspections/:inspectionId/issues/:issueId',
    name: 'equipmentIssue',
    component: EquipmentIssueForm,
    props: true,
  },
  {
    path: 'equipment/:equipmentId/inspections/:inspectionId/issues/new/location/equipment',
    name: 'equipmentNewIssueLocationEquipment',
    component: IssueLocationEquipment,
    props: true,
  },
  {
    path: 'equipment/:equipmentId/inspections/:inspectionId/issues/:issueId/location/equipment',
    name: 'equipmentIssueLocationEquipment',
    component: IssueLocationEquipment,
    props: true,
  },
  {
    path: 'equipment/:equipmentId/inspections/:inspectionId/issues/:issueId/history',
    name: 'equipmentIssueHistory',
    component: EquipmentIssueHistory,
    props: true,
  },
  {
    path: 'equipment/:equipmentId/equipment_health_reports/new',
    name: 'newEquipmentHealthReport',
    component: EquipmentHealthReportForm,
    props: true,
  },
  {
    path: 'equipment/:equipmentId/equipment_health_reports/:equipmentHealthReportId/edit',
    name: 'editEquipmentHealthReport',
    component: EquipmentHealthReportForm,
    props: true,
  },
];
